export default "__VITE_ASSET__b4sgM$ld__"